import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { FlxDoclistComponent } from './flx-doclist';

@NgModule({
  declarations: [
    FlxDoclistComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    FlxDoclistComponent
  ]
})
export class FlxDoclistComponentModule {}



// WEBPACK FOOTER //
// ./src/components/flx-doclist/flx-doclist.module.ts